import React from "react";
import Header from "../header/header";
import NavBar from "../nav/nav-bar";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import Footer from "../footer/footer";
import Service from "../webservice/http";
import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router";
import ClipLoader from "react-spinners/ClipLoader";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import agentIcon from "../assets/images/agent.png";
import infoIcon from "../assets/images/info.svg";
import infoIconred from "../assets/images/infored.svg";
import closeIcon from "../assets/images/close.svg";
import dropdownIcon from "../assets/images/dropdown.svg";
import { storage } from "../utils/storage";
import arrowDown from "../assets/images/arrow-down-black.svg";
import closeWhite from "../assets/images/close-white.svg";
import delivered from "../assets/images/delivered.png";
import readIcon from "../assets/images/read.png";
import add from "../assets/images/add.svg";
import dot from "../assets/images/dot.svg";

function AgentInsight() {
  // const [edit, setEdit] = useState({});
  const { id } = useParams();
  // console.log(useParams());
  const client = storage.getItem("client");
  const [edit, setEdit] = useState({});
  const services = new Service();
  const [Loading, setLoading] = useState(false);
  const [agentdata, setAgentdata] = useState("");
  const [editdata, setEditdata] = useState("");
  const [agentid, setAgentid] = useState("");
  const [activeTab, setActiveTab] = useState("add");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [days, setDays] = useState("30");
  const [qualityassurance, setQualityassurance] = useState([]);
  const [openDropdowns, setOpenDropdowns] = React.useState([]);
  const [chartdata, setChartdata] = useState([]);
  const [qamodal, setQamodal] = useState(false);
  const [note, setNote] = useState("");
  const [ptpmodal, setPtpmodal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedStates, setExpandedStates] = useState({});
  const [managerreview, setManagerreview] = useState(false);
  const [managerReviewData, setManagerReviewData] = useState([]);
  const [managercomments, setManagercomments] = useState("");
  const [deletereview, setDeletereview] = useState(false);
  const [feedbackid, setFeedbackid] = useState("");
  // const [isChecked, setIsChecked] = useState(false);
  const [readstatus, setReadstatus] = useState(false);

  // Toggle function to update the state for a specific index
  const toggleExpand = (index) => {
    setExpandedStates((prev) => ({
      ...prev,
      [index]: !prev[index] || false, // Toggle or set to false if undefined
    }));
  };

  const toggleDropdown = (index) => {
    setOpenDropdowns((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };
  console.log(agentdata);

  function fetchData() {
    setLoading(true);
    let url = `api/report/agent_details/${id}/`;
    if (days) {
      url = url + `?days=${days}`;
    }
    services.get(url).then((res) => {
      // console.log(res);
      setAgentdata(res);
      setAgentid(res?.id);

      setQualityassurance(res?.call_evaluation_scores || []);
      setChartdata(
        (() => {
          const data = res?.collection_metrics_chart_data.map(
            (item) =>
              ({
                name: item.name,
                value: parseInt(item.value), // or parseFloat for decimals
              }) || [],
          );

          const total = data.reduce((sum, item) => sum + item.value, 0);
          if (total < 100) {
            data.push({ name: "Others", value: 100 - total });
          }

          return data;
        })(),
      );
      setLoading(false);
    });
  }
  useEffect(() => {
    fetchData();
  }, [days]);

  const colors = [
    "#5A9BD5",
    "#70AD47",
    "#E74C3C",
    "#9E7ACB",
    "#F4B183",
    "#FFD966",
    "#A6A6A6",
    "#FF8C00",
  ];

  const data = chartdata.map((item) => ({
    name: item.name,
    value: item.value,
  }));

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setNote("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      const res = services.patch(`api/report/agent_details/${id}/`, {
        notes: note,
      });
      if (res) {
        NotificationManager.success(
          "Note submitted successfully",
          "Success",
          3000,
        );
        fetchData();
        setNote("");
      } else {
        NotificationManager.error("Failed to submit note", "Error", 3000);
      }
    } catch (error) {
      NotificationManager.error("Error submitting note", "Error", 3000);
      return;
    }
    // console.log("Note submitted:", note);
    handleCloseModal();
  };
  const handleEditClick = (index) => {
    setEdit((prev) => ({ [index]: true }));
    setEditdata("");
  };

  const handleSave = (id) => {
    services
      .patch(`api/report/agent_details/${agentid}/`, {
        id: id,
        voice_metrics_comments: editdata,
      })
      .then((res) => {
        // console.log("checkkkkkkk", res);
        // window.location.reload();
      });
    setEdit({});
    setEditdata("");
    fetchData();
  };

  useEffect(() => {
    if (isModalOpen || qamodal || ptpmodal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen, qamodal, ptpmodal]);

  const handleQaModal = () => {
    setQamodal(true);
  };

  const handlePTPModal = () => {
    setPtpmodal(true);
  };
  const filteredQualityAssurance = qualityassurance.filter((item) =>
    item?.details?.name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const fetchManagerFeedback = async () => {
    try {
      const response = await services.get(`api/report/manager_feedback/`);
      setManagerReviewData(response);
    } catch (error) {
      console.error("Error fetching manager feedback:", error);
      NotificationManager.error(
        error.response?.data?.message || "Failed to fetch manager feedback",
        "Error",
        3000,
      );
    }
  };

  useEffect(() => {
    fetchManagerFeedback();
  }, [ptpmodal]);

  const hasUnreadManagerReview = managerReviewData?.some(
    (feedback) => feedback.read_status === false,
  );

  console.log(hasUnreadManagerReview);

  const handleManagerReview = async () => {
    try {
      setManagerreview(true);

      const response = await services.post(`api/report/manager_feedback/`, {
        agent_id: id,
        comment: managercomments,
      });

      fetchManagerFeedback();
      setManagercomments("");
      setManagerreview(false);
      NotificationManager.success(
        "Manager feedback submitted successfully",
        "Success",
        3000,
      );

      fetchData();
    } catch (error) {
      console.error("Error submitting manager feedback:", error);
      setManagerreview(false);
      NotificationManager.error(
        error.response?.data?.message || "Failed to submit manager feedback",
        "Error",
        3000,
      );
    }
  };

  const handleDeleteReview = async () => {
    try {
      setDeletereview(true);
      await services.delete(`api/report/manager_feedback/${feedbackid}/`);

      NotificationManager.success(
        "Manager review deleted successfully",
        "Success",
        3000,
      );
      fetchManagerFeedback();
    } catch (error) {
      console.error("Error deleting manager review:", error);
      NotificationManager.error(
        error.response?.data?.message || "Failed to delete manager review",
        "Error",
        3000,
      );
    } finally {
      setDeletereview(false);
    }
  };
  // console.log("Manager Review Data:", managerReviewData);

  // console.log("Manager Review Data:", managerReviewData);

  const handleMarkAsRead = async (id) => {
    // if (isChecked) {
    try {
      const response = await services.post(
        `api/report/manager_feedback/${id}/mark_read/`,
        {
          read_status: true,
        },
      );
      if (response) {
        setReadstatus(true);
        NotificationManager.success("Marked as read", "Success", 3000);
        fetchManagerFeedback();
      }
    } catch (error) {
      console.error("Error marking as read:", error);
      NotificationManager.error(
        error.response?.data?.message || "Failed to mark as read",
        "Error",
        3000,
      );
    }
    // } else {
    //   NotificationManager.error(
    //     "Please check the checkbox to mark as read",
    //     "Error",
    //     3000
    //   );
    // }
  };

  return (
    <div className="dashboard-body">
      <Header />
      <NavBar />
      <NotificationContainer />

      {Loading ? (
        <div className="flex items-center justify-center h-screen">
          <ClipLoader color="#2056FF" size="50px" />
        </div>
      ) : !storage.getItem("usecase").includes("Collections") ? (
        <div>
          <div className="container-fluid">
            <div className="my-call">
              <div className="">
                <div
                  className="call-table-s"
                  style={{ width: "100%", height: "auto" }}
                >
                  <div className="my-calls-column">
                    <div className="calls-top-pannel">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="pannel-heading clearfix">
                            <div className="pannel-heading-icon">
                              <i
                                className="fa fa-snowflake-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="pannel-heading-info">
                              <h3>Agent Individual Scorecard </h3>
                              <p>Details</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                  <div
                    className=" flex py-10"
                    style={{
                      border: "1px solid lightgray",
                      paddingLeft: "200px",
                      paddingRight: "200px",
                      backgroundColor: "white",
                    }}
                  >
                    <div
                      className="w-1/2 flex"
                      //
                    >
                      <div className=" flex  flex-col w-1/2 text-end mr-4">
                        <span className=" bg-green-500 text-white mb-2 py-4 px-10 ">
                          Name of Agent
                        </span>
                        <span className=" bg-green-500 text-white mb-2 py-4 px-10 ">
                          Department
                        </span>
                        <span className=" bg-green-500 text-white mb-2 py-4 px-10 ">
                          Account
                        </span>
                        <span className=" bg-green-500 text-white mb-2 py-4 px-10 ">
                          Team Lead
                        </span>
                        <span className=" bg-green-500 text-white mb-2 py-4 px-10 ">
                          Total calls
                        </span>
                      </div>
                      <div className=" flex  flex-col w-1/2 text-center">
                        <span className=" bg-gray-300 text-black mb-2 py-4  px-16 ">
                          {agentdata?.agent_name}
                        </span>
                        <span className=" bg-gray-300 text-black mb-2 py-4  px-16 ">
                          {agentdata?.department}
                        </span>
                        <span className=" bg-gray-300 text-black mb-2 py-4  px-16 ">
                          {agentdata?.account}
                        </span>
                        <span className=" bg-gray-300 text-black mb-2 py-4  px-16 ">
                          {agentdata?.team_lead}
                        </span>
                        <span className=" bg-gray-300 text-black mb-2 py-4  px-16 ">
                          {agentdata?.total_calls || 5}
                        </span>
                      </div>
                    </div>
                    <div
                      className=" w-1/2"
                      // style={{ border: "1px solid red" }}
                    >
                      <div
                        className=""
                        //   style={{ paddingBottom: "30px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={services.domain + agentdata?.agent_image}
                            alt="Admin"
                            class="p-1 bg-primary rounded-full"
                            // width="125"
                            // height="125"
                            style={{ height: "125px", width: "125px" }}
                          />
                        </div>
                        <span
                          className=" flex justify-center mt-6 text-black text-2xl font-extrabold uppercase"
                          // style={{ margin: "20px" }}
                        >
                          Score
                        </span>
                        <span className=" flex justify-center mt-4">
                          <div
                            className=" h-20 flex justify-center items-center bg-gray-100 text-3xl font-bold"
                            //   style={{ border: "1px solid blue" }}
                            style={{ width: "50%" }}
                          >
                            {agentdata?.score}
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="pb-24 mt-6">
                    <div className="overflow-x-auto">
                      <table
                        className="m"
                        style={{ border: "1px solid lightgray", width: "100%" }}
                      >
                        <thead className=" border-b-2 lightgray">
                          <tr>
                            <th className="px-6 py-3 text-left text-xl  text-black font-extrabold uppercase tracking-wider">
                              Metrics
                            </th>
                            <th className="px-6 py-3 text-left text-xl  text-black font-extrabold uppercase tracking-wider">
                              Weightage
                            </th>
                            <th className="px-6 py-3 text-left text-xl  text-black font-extrabold uppercase tracking-wider">
                              Score
                            </th>
                            <th className="px-6 py-3 text-left text-xl  text-black font-extrabold uppercase tracking-wider">
                              Weighted Score
                            </th>
                            <th className="px-6 py-3 text-left text-xl  text-black font-extrabold uppercase tracking-wider">
                              Notes/comments
                            </th>
                          </tr>
                        </thead>

                        {Loading && (
                          <tr>
                            <td colSpan="10" style={{ textAlign: "center" }}>
                              <ClipLoader color="#2056FF" size="50px" />
                            </td>
                          </tr>
                        )}

                        <tbody className="agent-scorecard">
                          <tr
                            className="bg-white "
                            style={{ backgroundColor: "white" }}
                          >
                            <td
                              style={{
                                fontWeight: "bold",
                                fontSize: "18px",
                                backgroundColor: "#F5F7F8",
                              }}
                              className="p-4"
                            >
                              Voice
                            </td>
                          </tr>
                          {agentdata?.metrics?.map((e, index) => (
                            <tr
                              key={index}
                              className={`m-4 ${
                                index % 2 === 0 ? " bg-gray-200" : "bg-white"
                              }`}
                            >
                              <td className="px-6 py-4 whitespace-nowrap text-xl text-black">
                                {e?.voice_metrics}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-xl text-black">
                                {e?.voice_weighting}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-xl text-black">
                                {e?.voice_score}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-xl text-black">
                                {e?.voice_wighted_score}
                              </td>
                              {!edit[index] ? (
                                <td className="px-6 py-4 whitespace-nowrap text-xl text-black flex">
                                  {e?.voice_metrics_comments}{" "}
                                  <span
                                    className=" ml-8 cursor-pointer"
                                    onClick={() => handleEditClick(index)}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      class="bi bi-pencil"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                    </svg>
                                  </span>
                                </td>
                              ) : (
                                <td className="px-6 py-4 whitespace-nowrap text-xl text-black flex">
                                  <input
                                    type="text"
                                    defaultValue={e?.voice_metrics_comments}
                                    className="py-1 rounded-xl px-4 "
                                    style={{
                                      border: "1px solid lightgray",
                                      width: "400px",
                                    }}
                                    onChange={(e) => {
                                      setEditdata(e.target.value);
                                    }}
                                  ></input>
                                  {/* {e?.comments}{" "} */}
                                  <span className=" ml-8 cursor-pointer">
                                    <button
                                      className="px-4 py-1"
                                      style={{ border: "1px solid lightgray" }}
                                      onClick={() => handleSave(e?.id)}
                                    >
                                      Save
                                    </button>
                                    <button
                                      className="px-4 py-1 ml-2"
                                      style={{ border: "1px solid lightgray" }}
                                      onClick={() => {
                                        setEdit((prevEdit) => ({
                                          ...prevEdit,
                                          [index]: false,
                                        }));
                                        setEditdata(false);
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </span>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="container-fluid">
            <div
              className="my-call my-agent"
              style={{ backgroundColor: "none" }}
            >
              <div className="">
                <div
                  className="call-table-s"
                  style={{ width: "100%", height: "auto" }}
                >
                  <div className="my-calls-column">
                    <div className="calls-top-pannel">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="pannel-heading clearfix">
                            <div className="pannel-heading-icon">
                              <i
                                className="fa fa-snowflake-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="pannel-heading-info">
                              <h3>Agent Individual Scorecard </h3>
                              <p>Details</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-6">
                    <div className="flex-1 bg-white shadow-sm rounded-2xl p-6 flex">
                      <div className="w-1/2 grid grid-rows-5 gap-8">
                        {[
                          ["Name of Agent", agentdata?.agent_name] || "--",
                          ["Department", agentdata?.department] || "--",
                          ["Account", agentdata?.account || "--"],
                          ["Team Lead", agentdata?.team_lead || "--"],
                          ["Total Calls", agentdata?.total_calls || "--"],
                        ].map(([label, value]) => (
                          <div
                            key={label}
                            className="flex justify-between items-center"
                          >
                            <span className="text-2xl font-medium text-gray-600">
                              {label}
                            </span>
                            <span className="text-2xl font-semibold text-gray-800">
                              {value}
                            </span>
                          </div>
                        ))}
                      </div>

                      <div className="w-1/2 flex flex-col items-center justify-center space-y-4">
                        <div className="p-1 bg-gray-200 rounded-full">
                          <img
                            src={
                              agentdata?.agent_image
                                ? `${services.domain}/${agentdata?.agent_image}`
                                : agentIcon
                            }
                            alt="Agent"
                            className="w-36 h-36 rounded-full object-cover"
                          />
                        </div>
                        <div className="text-lg font-medium text-gray-600 uppercase">
                          Score
                        </div>
                        <div className="w-1/2 py-2 bg-gray-100 rounded-lg text-center text-2xl font-bold text-gray-800">
                          {agentdata?.score}
                        </div>
                      </div>
                    </div>
                    <div className="w-1/3 bg-white shadow-inner rounded-2xl p-6 flex flex-col items-center">
                      <ResponsiveContainer width="100%" height={250}>
                        <PieChart>
                          <Pie
                            data={data}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius={100}
                            labelLine={false}
                            label={({ percent }) =>
                              percent > 0.01
                                ? `${(percent * 100).toFixed(0)}%`
                                : ""
                            }
                          >
                            {data.map((entry, idx) => (
                              <Cell key={entry.name} fill={colors[idx]} />
                            ))}
                          </Pie>
                          <Tooltip
                            formatter={(value, name) => [`${value}%`, name]}
                            contentStyle={{
                              borderRadius: 8,
                              borderColor: "#CBD5E0",
                            }}
                          />
                        </PieChart>
                      </ResponsiveContainer>

                      <div className="mt-4 text-center">
                        {/* Add breakdown of metrics */}
                        <div className="mt-4 flex gap-2">
                          {chartdata.map((item, index) => (
                            <div
                              key={index}
                              className="flex justify-between items-center text-gray-600  text-lg "
                            >
                              <span className="font-bold text-sm whitespace-nowrap text-black">
                                {item.name} {item.value},
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="pb-24 mt-6 bg-white rounded-xl">
                    <div className="my-calls-column rounded-xl">
                      <div className="calls-top-pannel">
                        <div className="row">
                          <div className="flex justify-between px-6">
                            <div className="pannel-heading clearfix">
                              <div className="pannel-heading-icon">
                                <i
                                  className="fa fa-snowflake-o"
                                  aria-hidden="true"
                                ></i>
                              </div>
                              <div className="pannel-heading-info">
                                <h3>Collection Metrics</h3>
                                <p>Details</p>
                              </div>
                            </div>
                            <div className="p-4">
                              <button
                                className="px-4 py-2 bg-gray-300 text-black rounded hover:text-white hover:bg-blue-900 hover:ease-in-out"
                                onClick={handleOpenModal}
                              >
                                <i className="fa fa-plus mr-2"></i>
                                Notes
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-end px-8 mb-8">
                      <div
                        style={{
                          border: "1px solid lightgray",
                          // borderRadius: "5px",
                        }}
                        className={`flex cursor-pointer `}
                      >
                        <button
                          className={`px-4 py-2 ${
                            days === "1"
                              ? "bg-blue-900 text-white"
                              : "bg-gray-200 text-gray-700"
                          }`}
                          style={{ borderRight: "1px solid lightgray" }}
                          onClick={() => setDays("1")}
                          disabled={days === "1"}
                        >
                          1 Day
                        </button>
                        <button
                          className={`px-4 py-2 ${
                            days === "7"
                              ? "bg-blue-900 text-white"
                              : "bg-gray-200 text-gray-700"
                          }`}
                          style={{ borderRight: "1px solid lightgray" }}
                          onClick={() => setDays("7")}
                          disabled={days === "7"}
                        >
                          7 Days
                        </button>
                        <button
                          className={`px-4 py-2 ${
                            days === "30"
                              ? "bg-blue-900 text-white"
                              : "bg-gray-200 text-gray-700"
                          }`}
                          onClick={() => setDays("30")}
                          disabled={days === "30"}
                        >
                          30 Days
                        </button>
                      </div>
                    </div>
                    <div className="flex gap-10 flex-wrap mb-8 px-8">
                      <div
                        className={`bg-white relative p-2 h-24  flex gap-6 shadow-lg flex-row items-center justify-center w-1/5 border border-gray-300 text-center mx-2 rounded`}
                        style={{ height: "90px", width: "23%" }}
                      >
                        <div className=" flex flex-col items-center justify-center">
                          <div className="text-3xl font-bold">
                            Promise To Pay(PTP)
                          </div>
                          <div className="text-2xl">
                            {agentdata?.collection_metrics?.ptp_rate}
                          </div>
                        </div>
                        <div
                          onClick={handlePTPModal}
                          className="cursor-pointer group relative"
                        >
                          <span>
                            <img
                              src={
                                hasUnreadManagerReview &&
                                storage.getItem("role").includes("Agent")
                                  ? infoIconred
                                  : infoIcon
                              }
                              alt="info-icon"
                              // className={`relative ${
                              //   hasUnreadManagerReview
                              //     ? "border-2 border-red-500"
                              //     : ""
                              // }`}
                            />
                            {storage.getItem("role").includes("Agent") &&
                              hasUnreadManagerReview && (
                                <span
                                  className="absolute top-8 left-1/2 transform -translate-x-1/2 mt-2 opacity-0 group-hover:opacity-100 transition-opacity shadow-xl  w-64 p-2 rounded z-20 text-xl text-red-600 font-bold flex items-center gap-1 justify-center"
                                  style={{ border: "1px solid lightgray" }}
                                >
                                  <img
                                    src={dot}
                                    alt="dot"
                                    className="h-4 w-4"
                                  />
                                  New Manager Review
                                </span>
                              )}
                          </span>
                        </div>

                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "#03A6A1" }}
                        ></div>
                      </div>
                      <div
                        className="bg-white relative p-2 h-24  flex gap-4 shadow-lg flex-col justify-center w-1/5 border border-gray-300 text-center mx-2 rounded overflow-hidden"
                        style={{ height: "90px", width: "23%" }}
                      >
                        <div className="text-3xl font-bold">Kept Rate</div>
                        <div className="text-2xl">
                          {agentdata?.collection_metrics?.kept_rate || "--"}
                        </div>
                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "#FF3F33" }}
                        ></div>
                      </div>
                      <div
                        className="bg-white relative p-2 h-24 flex gap-4 shadow-lg flex-col justify-center w-1/5 border border-gray-300 text-center mx-2 rounded overflow-hidden"
                        style={{ height: "90px", width: "23%" }}
                      >
                        <div className="text-3xl font-bold">
                          Promise To Pay Count
                        </div>
                        <div className="text-2xl">
                          {agentdata?.collection_metrics?.ptp_count}
                        </div>
                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "#16610E" }}
                        ></div>
                      </div>
                      <div
                        className="bg-white relative p-2 h-24 flex gap-4 flex-col shadow-lg justify-center w-1/5 border border-gray-300 text-center mx-2 rounded overflow-hidden"
                        style={{
                          height: "90px",
                          width: "23%",
                        }}
                      >
                        <div className="text-3xl font-bold">
                          Collected Amount
                        </div>
                        <div className="text-2xl">
                          {`${client.includes("Maya") ? "₱" : "$"} ${
                            agentdata?.collection_metrics?.collected_amount
                          }`}
                        </div>
                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "#FE7743" }}
                        ></div>
                      </div>
                      <div
                        className="bg-white relative p-2 h-24  flex gap-12 shadow-lg flex-row items-center justify-center w-1/5 border border-gray-300 text-center mx-2 rounded overflow-hidden"
                        style={{ height: "90px", width: "23%" }}
                      >
                        <div className=" flex flex-col items-center justify-center">
                          <div className="text-3xl font-bold">
                            Quality Assurance
                          </div>
                          <div className="text-2xl">
                            {agentdata?.collection_metrics?.qa_score}
                          </div>
                        </div>
                        <div onClick={handleQaModal} className="cursor-pointer">
                          <img src={infoIcon} alt="info-icon" />
                        </div>

                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "#D6D85D" }}
                        ></div>
                      </div>
                      <div
                        className="bg-white relative p-2 h-24  flex shadow-lg gap-4 flex-col justify-center w-1/5 border border-gray-300 text-center mx-2 rounded overflow-hidden"
                        style={{ height: "90px", width: "23%" }}
                      >
                        <div className="text-3xl font-bold">
                          Average Handling Time per call
                        </div>
                        <div className="text-2xl">
                          {agentdata?.collection_metrics?.aht}
                        </div>
                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "#0D5EA6" }}
                        ></div>
                      </div>
                      <div
                        className="bg-white relative p-2 h-24  flex gap-4 shadow-lg flex-col justify-center w-1/5 border border-gray-300 text-center mx-2 rounded overflow-hidden"
                        style={{ height: "90px", width: "23%" }}
                      >
                        <div className="text-3xl font-bold">Flow Rate</div>
                        <div className="text-2xl">
                          {agentdata?.collection_metrics?.flow_rate}
                        </div>
                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "#BE5985" }}
                        ></div>
                      </div>
                      {/* <div
                        className="bg-white relative p-2 h-24  flex gap-4 shadow-lg flex-col justify-center w-1/5 border border-gray-300 text-center mx-2 rounded overflow-hidden"
                        style={{ height: "90px", width: "23%" }}
                      >
                        <div className="text-3xl font-bold">Total Calls</div>
                        <div className="text-2xl">
                          {agentdata?.collection_metrics?.total_call}
                        </div>
                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "#7F55B1" }}
                        ></div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className="bg-white rounded-lg p-6 w-full "
            style={{ width: "500px", height: "300px" }}
          >
            <div className="flex flex-col">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-semibold">Notes</h2>
                <button
                  className="text-gray-500 hover:text-gray-700"
                  onClick={handleCloseModal}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>
              <div className="flex mb-4">
                <button
                  className={`px-4 py-2 font-medium rounded-t-md ${
                    activeTab === "add"
                      ? "bg-blue-900 text-white"
                      : "bg-gray-200 text-gray-700"
                  }`}
                  onClick={() => setActiveTab("add")}
                >
                  Add Notes
                </button>
                <button
                  className={`px-4 py-2 font-medium rounded-t-md ${
                    activeTab === "view"
                      ? "bg-blue-900 text-white"
                      : "bg-gray-200 text-gray-700"
                  }`}
                  onClick={() => setActiveTab("view")}
                >
                  View Notes
                </button>
              </div>
            </div>
            {activeTab === "add" ? (
              <>
                <div className="mt-4">
                  <textarea
                    className="bg-gray-200 w-full h-52 p-2 rounded border border-gray-300"
                    style={{ resize: "none" }}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Enter your note here..."
                  ></textarea>
                </div>
                <div className="mt-6 flex justify-end space-x-2 ">
                  <button
                    className="px-4 py-2 bg-gray-300 text-black rounded  hover:text-white hover:bg-red-600 hover:ease-in-out"
                    onClick={handleCloseModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-blue-900 hover:ease-in-out hover:text-white"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </>
            ) : (
              activeTab === "view" && (
                <div className="mt-4 overflow-y-auto h-64">
                  {
                    // agentdata?.notes?.length
                    4 > 0 ? (
                      // agentdata?.notes

                      agentdata?.notes?.map((note, index) => (
                        <div
                          key={index}
                          className="text-gray-600 rounded-lg py-4 px-2 mb-2"
                          style={{ border: "1px solid lightgray" }}
                        >
                          {/* {note.note_text} */}
                          <ul>
                            <li>
                              <strong>Note {index + 1}:</strong> {note}.
                            </li>
                          </ul>
                        </div>
                      ))
                    ) : (
                      <div
                        className="text-gray-600 rounded-lg py-4 px-2"
                        style={{ border: "1px solid lightgray" }}
                      >
                        No notes available.
                      </div>
                    )
                  }
                </div>
              )
            )}
          </div>
        </div>
      )}

      {qamodal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className="bg-white rounded-2xl shadow-2xl mx-4 text-xl"
            style={{ width: "800px", height: "450px" }}
          >
            <div className="flex items-center justify-between p-6">
              <h4 className="font-semibold text-gray-900">Quality Assurance</h4>
              <button
                className="text-gray-400 hover:text-gray-600 transition-colors p-1"
                onClick={() => setQamodal(false)}
              >
                <img src={closeIcon} alt="Close" className="h-8 w-8" />
              </button>
            </div>
            <div className="p-6 pb-2 pt-2">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="h-6 w-6 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Search metrics"
                  style={{ background: "#F0F0F0" }}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-10 pr-4 rounded-3xl py-2 border
                border-gray-300 h-14 placeholder:text-lg"
                />
              </div>
            </div>
            <div
              className="px-6 pb-6 overflow-y-auto mt-8"
              style={{
                fontSize: "16px",
                height: "300px",
                // border: "1px solid #E5E7EB",
              }}
            >
              <div className="space-y-1">
                {filteredQualityAssurance.length ? (
                  filteredQualityAssurance?.map((e, index) => (
                    <div key={index}>
                      <div className="flex items-center justify-between py-3 hover:bg-gray-50 rounded-md px-3 -mx-3">
                        <span className="text-gray-700 font-bold">
                          {e?.details?.name}
                        </span>
                        <div className="flex items-center">
                          <span className="font-mono bg-gray-100 px-2 py-1 rounded text-gray-900">
                            {e?.details?.score}
                          </span>
                          <button
                            className="ml-2 text-gray-400 hover:text-gray-600 transition-colors p-1"
                            onClick={() => toggleDropdown(index)}
                          >
                            <img
                              src={dropdownIcon}
                              alt="Dropdown"
                              className="h-8 w-8"
                            />
                          </button>
                        </div>
                      </div>
                      <div
                        className={`ml-6 overflow-hidden transition-all duration-300 ease-in-out mx-10
                         ${
                           openDropdowns.includes(index)
                             ? "max-h-40"
                             : "max-h-0"
                         }
                      `}
                      >
                        {e?.metrics.map((subMetric, subIndex) => (
                          <div
                            key={subIndex}
                            className="flex items-center justify-between py-2"
                          >
                            <span className="text-gray-600">
                              {subMetric?.name
                                .split("_")
                                .map((e) => e[0].toUpperCase() + e.slice(1))
                                .join(" ")}
                            </span>
                            <span className="font-mono bg-gray-100 px-2 py-1 rounded text-gray-900">
                              {subMetric?.score}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="flex justify-center font-medium">
                    {" "}
                    No Quality Assurance Parameters Found
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {true && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className="bg-white rounded-lg p-6 w-full "
            style={{ width: "800px", height: "500px" }}
          >
            <div className="flex flex-col">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-semibold">Promise To Pay</h2>
                <button
                  className="text-gray-500 hover:text-gray-700"
                  onClick={() => setPtpmodal(false)}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>
              <div className="mt-4">
                <p>
                  Promise to pay rate for the agent is{" "}
                  {agentdata?.collection_metrics?.ptp_rate || "--"}.
                </p>
              </div>
            </div>
          </div>
        </div>
      )} */}
      {ptpmodal && (
        <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-30">
          <div
            className="bg-white rounded-lg p-6 w-full overflow-y-auto"
            style={{ width: "900px", height: "600px" }}
          >
            <div className="flex flex-col h-full">
              <div className="flex justify-between items-center">
                <h2 className="text-gray-800 mb-2" style={{ fontSize: "20px" }}>
                  Promise To Pay Analytics
                </h2>
                <button
                  className="text-gray-500 hover:text-gray-700 text-3xl"
                  onClick={() => setPtpmodal(false)}
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              {/* Content */}
              <div className="flex-1 overflow-y-auto space-y-6">
                {/* Current Performance Summary */}
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="text-gray-700" style={{ fontSize: "14px" }}>
                    Current Performance - {agentdata?.agent_name} (
                    {agentdata?.agent_drill_down.current_performance.week})
                  </h3>
                  <div className="grid grid-cols-4 gap-4">
                    <div className="text-center">
                      <div
                        className="text-blue-600 font-bold"
                        style={{ fontSize: "16px" }}
                      >
                        {
                          agentdata?.agent_drill_down.current_performance
                            .ptp_rate
                        }
                        %
                      </div>
                      <div
                        className="text-gray-600 mt-2"
                        style={{ fontSize: "14px" }}
                      >
                        PTP Rate
                      </div>
                    </div>
                    <div className="text-center">
                      <div
                        className="text-green-600 font-bold"
                        style={{ fontSize: "16px" }}
                      >
                        {
                          agentdata.agent_drill_down.current_performance
                            .total_ptps
                        }
                      </div>
                      <div
                        className="text-gray-600"
                        style={{ fontSize: "14px" }}
                      >
                        Total PTPs
                      </div>
                    </div>
                    <div className="text-center">
                      <div
                        className="text-purple-600 font-bold"
                        style={{ fontSize: "16px" }}
                      >
                        {
                          agentdata.agent_drill_down.current_performance
                            .total_rpcs
                        }
                      </div>
                      <div
                        className="text-gray-600"
                        style={{ fontSize: "14px" }}
                      >
                        Total RPCs
                      </div>
                    </div>
                    <div className="text-center">
                      <div
                        className={`px-2 py-4 rounded ${
                          agentdata.agent_drill_down.current_performance
                            .performance_status === "Below Target"
                            ? "bg-red-100 text-red-700"
                            : "bg-green-100 text-green-700"
                        }`}
                        style={{ fontSize: "14px" }}
                      >
                        {
                          agentdata.agent_drill_down.current_performance
                            .performance_status
                        }
                      </div>
                    </div>
                  </div>
                </div>
                {storage.getItem("role").includes("Master") && (
                  <div className="w-full p-4 space-y-6 bg-white">
                    <h3
                      className="text-gray-700 mb-8"
                      style={{ fontSize: "14px" }}
                    >
                      Manager Insights - Weekly Performance
                    </h3>
                    <div className="space-y-6">
                      {agentdata.manager_drill_down.weekly_performance.map(
                        (w, i) => (
                          <div className="rounded-lg p-6 bg-gray-50 space-y-4">
                            <div
                              className="flex justify-between items-center cursor-pointer"
                              onClick={() => toggleExpand(i)}
                            >
                              <h4
                                className="text-gray-800"
                                style={{ fontSize: "14px" }}
                              >
                                {w.week}
                              </h4>
                              <div className="flex items-center">
                                <div
                                  className="text-gray-600"
                                  style={{ fontSize: "14px" }}
                                >
                                  PTP Rate:{" "}
                                  {Math.round(
                                    (w.funnel_breakdown.full_settlement_ptps /
                                      w.funnel_breakdown.total_rpcs) *
                                      100,
                                  ) || 0}
                                  %
                                </div>
                                <span className="ml-2 text-gray-500 text-xl">
                                  {expandedStates[i] ? (
                                    <img
                                      src={arrowDown}
                                      alt="arrow-down"
                                      className="transform rotate-180"
                                    />
                                  ) : (
                                    <img src={arrowDown} alt="arrow-down" />
                                  )}
                                </span>
                              </div>
                            </div>
                            <div
                              className={`transition-all duration-300 ease-in-out ${
                                expandedStates[i]
                                  ? "max-h-[1000px] opacity-100"
                                  : "max-h-0 opacity-0 overflow-hidden"
                              }`}
                            >
                              <div className="space-y-4">
                                <div className="grid grid-cols-2 gap-6">
                                  <div className="text-center bg-blue-50 p-4 rounded">
                                    <div
                                      className="text-blue-600"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {w.funnel_breakdown.total_rpcs}
                                    </div>
                                    <div
                                      className="text-gray-600"
                                      style={{ fontSize: "14px" }}
                                    >
                                      Total RPCs
                                    </div>
                                  </div>
                                  <div className="text-center bg-green-50 p-4 rounded">
                                    <div
                                      className="text-green-600"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {w.funnel_breakdown.full_settlement_ptps}
                                    </div>
                                    <div
                                      className="text-gray-600"
                                      style={{ fontSize: "14px" }}
                                    >
                                      Full Settlement PTPs
                                    </div>
                                  </div>
                                </div>
                                <div className="grid grid-cols-4 gap-6 p-4">
                                  {w.segmentation.map((seg, j) => (
                                    <div
                                      key={j}
                                      className="bg-white p-4 rounded-lg text-center space-y-2"
                                    >
                                      <div
                                        className="text-gray-700"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {seg.characteristic}
                                      </div>
                                      <div
                                        className="text-blue-600"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {seg.ptp_rate}
                                      </div>
                                      <div
                                        className="text-gray-500"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {seg.full_settlement_ptps}/
                                        {seg.total_rpcs}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                )}

                {/* Weekly Performance Trend */}
                <div>
                  <h3
                    className="text-gray-700 mb-3"
                    style={{ fontSize: "14px" }}
                  >
                    Weekly Performance Trend
                  </h3>
                  <div className="overflow-x-auto">
                    <table className="w-full" style={{ fontSize: "14px" }}>
                      <thead>
                        <tr className="bg-gray-100">
                          <th
                            className="px-3 py-2 text-left"
                            style={{ fontSize: "14px" }}
                          >
                            Week
                          </th>
                          <th
                            className="px-3 py-2 text-center"
                            style={{ fontSize: "14px" }}
                          >
                            PTP Rate
                          </th>
                          <th
                            className="px-3 py-2 text-center"
                            style={{ fontSize: "14px" }}
                          >
                            Change
                          </th>
                          <th
                            className="px-3 py-2 text-left"
                            style={{ fontSize: "14px" }}
                          >
                            Notes
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {agentdata.agent_drill_down.weekly_status.map(
                          (week, i) => (
                            <tr key={i} className="border-b">
                              <td
                                className="px-3 py-2"
                                style={{ fontSize: "14px" }}
                              >
                                {week.week}
                              </td>
                              <td
                                className="px-3 py-2 text-center"
                                style={{ fontSize: "14px" }}
                              >
                                {week.ptp_rate}%
                              </td>
                              <td className="px-3 py-2 text-center">
                                <span
                                  className={`px-2 py-1 rounded text-xs ${
                                    week.change_type === "baseline"
                                      ? "bg-gray-100 text-gray-700"
                                      : week.change_type === "degraded"
                                        ? "bg-red-100 text-red-700"
                                        : "bg-green-100 text-green-700"
                                  }`}
                                  style={{ fontSize: "14px" }}
                                >
                                  {week.status_change === "0"
                                    ? "Baseline"
                                    : `${week.status_change}%`}
                                </span>
                              </td>
                              <td
                                className="px-3 py-2 text-gray-600"
                                style={{ fontSize: "14px" }}
                              >
                                {week.notes}
                              </td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Team Comparison */}
                <div>
                  <h3
                    className="text-gray-700 mb-8"
                    style={{ fontSize: "14px" }}
                  >
                    Team Comparison
                  </h3>
                  <div className="overflow-x-auto">
                    <table className="w-full" style={{ fontSize: "14px" }}>
                      <thead>
                        <tr className="bg-gray-100">
                          <th
                            className="px-3 py-2 text-left"
                            style={{ fontSize: "14px" }}
                          >
                            Week
                          </th>
                          <th
                            className="px-3 py-2 text-center"
                            style={{ fontSize: "14px" }}
                          >
                            Your PTP Rate
                          </th>
                          <th
                            className="px-3 py-2 text-center"
                            style={{ fontSize: "14px" }}
                          >
                            Team Avg
                          </th>
                          <th
                            className="px-3 py-2 text-center"
                            style={{ fontSize: "14px" }}
                          >
                            Difference
                          </th>
                          <th
                            className="px-3 py-2 text-center"
                            style={{ fontSize: "14px" }}
                          >
                            Your PTPs
                          </th>
                          <th
                            className="px-3 py-2 text-center"
                            style={{ fontSize: "14px" }}
                          >
                            Your RPCs
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {agentdata.agent_drill_down.team_comparison.map(
                          (week, i) => (
                            <tr key={i} className="border-b">
                              <td
                                className="px-3 py-2"
                                style={{ fontSize: "14px" }}
                              >
                                {week.week}
                              </td>
                              <td
                                className="px-3 py-2 text-center"
                                style={{ fontSize: "14px" }}
                              >
                                {week.your_ptp_rate}%
                              </td>
                              <td
                                className="px-3 py-2 text-center"
                                style={{ fontSize: "14px" }}
                              >
                                {week.team_avg_ptp_rate}%
                              </td>
                              <td className="px-3 py-2 text-center">
                                <span
                                  className={`px-2 py-1 rounded text-xs ${
                                    week.status === "above_average"
                                      ? "bg-green-100 text-green-700"
                                      : "bg-red-100 text-red-700"
                                  }`}
                                  style={{ fontSize: "14px" }}
                                >
                                  {week.difference}
                                </span>
                              </td>
                              <td
                                className="px-3 py-2 text-center"
                                style={{ fontSize: "14px" }}
                              >
                                {week.your_ptps}
                              </td>
                              <td
                                className="px-3 py-2 text-center"
                                style={{ fontSize: "14px" }}
                              >
                                {week.your_rpcs}
                              </td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Manager Feedback */}
                <div className="w-full p-4 space-y-6 bg-white mt-8">
                  <div className=" flex justify-between items-center">
                    <h3 style={{ fontSize: "14px" }}>Manager Feedback</h3>
                    {storage.getItem("role") === "Master Collections" && (
                      // <button
                      //   className="h-8 w-8 font-boldp-2 rounded-full flex justify-center items-center hover:bg-red-600 hover:text-white"
                      //   style={{
                      //     border: "1px solid gray",
                      //     // backgroundColor: "white",
                      //   }}
                      //   onClick={() => setManagerreview(true)}
                      // >
                      //   +
                      // </button>
                      <img
                        src={add}
                        alt="add-icon"
                        className="cursor-pointer hover:filter-red"
                        onClick={() => setManagerreview(true)}
                      />
                    )}
                  </div>
                  {managerReviewData?.length === 0 ? (
                    <div className="text-center mt-4 space-y-6">
                      <div className=" text-gray-500 ">
                        No feedback available.
                      </div>
                      {storage.getItem("role") === "Master Collections" && (
                        <button
                          className="btn btn-secondary"
                          style={{
                            background: "#0168D9",
                            color: "white",
                          }}
                          onClick={() => setManagerreview(true)}
                        >
                          Add
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="space-y-6">
                      {storage.getItem("role") === "Master Collections"
                        ? managerReviewData?.map((fb, i) => (
                            <div
                              key={i}
                              className={`p-6 rounded-lg border-l-4 bg-gray-100 border-gray-300"`}
                            >
                              <div className="flex justify-between items-start mb-2">
                                <div
                                  className="text-gray-800"
                                  style={{ fontSize: "14px" }}
                                >
                                  {fb.manager_name}
                                </div>
                                <div
                                  className="text-gray-500"
                                  style={{ fontSize: "14px" }}
                                >
                                  {fb.date}
                                </div>
                              </div>

                              <div className="flex justify-between items-center gap-4 w-full">
                                <div
                                  className="text-gray-600 overflow-hidden text-ellipsis"
                                  style={{ fontSize: "14px" }}
                                >
                                  {fb.comment}
                                </div>
                                <div
                                  onClick={() => {
                                    setDeletereview(true);
                                    setFeedbackid(fb?.feedback_id);
                                  }}
                                  className="bg-gray-500 hover:bg-red-600 rounded-full h-6 w-6 cursor-pointer flex justify-center items-center flex-shrink-0"
                                >
                                  <img src={closeWhite} alt="delbtn" />
                                </div>
                              </div>
                              <div className=" flex ">
                                <img
                                  src={!fb.read_status ? delivered : readIcon}
                                  alt="delivered"
                                  className="h8 w-8"
                                />
                                {!fb.read_status ? (
                                  <span className="text-gray-500 ml-2">
                                    Posted
                                  </span>
                                ) : (
                                  <span
                                    className="ml-2"
                                    style={{ color: "#237F07" }}
                                  >
                                    Read
                                  </span>
                                )}
                              </div>
                            </div>
                          ))
                        : managerReviewData?.map((fb, i) => (
                            <div
                              key={i}
                              className={`p-6 rounded-lg border-l-4 ${
                                fb.read_status
                                  ? "bg-gray-50 border-gray-300"
                                  : "bg-blue-50 border-blue-400"
                              }`}
                            >
                              <div className="flex justify-between items-start mb-2">
                                <div
                                  className="text-gray-800"
                                  style={{ fontSize: "14px" }}
                                >
                                  {fb.manager_name}
                                </div>
                                <div></div>
                                <div
                                  className="text-gray-500"
                                  style={{ fontSize: "14px" }}
                                >
                                  {fb.date}
                                </div>
                              </div>
                              <div
                                className="text-gray-600"
                                style={{ fontSize: "14px" }}
                              >
                                {fb.comment}
                              </div>
                              {!fb.read_status && (
                                <div
                                  className="text-blue-600 mt-2 flex items-center justify-between"
                                  style={{ fontSize: "14px" }}
                                >
                                  New{" "}
                                  <span className="flex items-center gap-4">
                                    {/* <input
                                      type="checkbox"
                                      style={{ marginTop: "0px" }}
                                      checked={
                                        isChecked[fb.feedback_id] || false
                                      } // Use feedback_id to track individual state
                                      onChange={(e) =>
                                        setIsChecked((prev) => ({
                                          ...prev,
                                          [fb.feedback_id]: e.target.checked,
                                        }))
                                      }
                                    />{" "} */}
                                    <span
                                      onClick={() =>
                                        handleMarkAsRead(fb?.feedback_id)
                                      }
                                      className="cursor-pointer hover:text-blue-500"
                                    >
                                      Mark As Read
                                    </span>
                                  </span>
                                </div>
                              )}
                            </div>
                          ))}
                    </div>
                  )}
                </div>
                {managerreview && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
                    <div
                      className="bg-white rounded-lg p-6 shadow-lg "
                      style={{ width: "400px" }}
                    >
                      <div className=" flex justify-center items-center">
                        <h4
                          className="text-gray-700 font-bold mb-4"
                          style={{ fontSize: "16px" }}
                        >
                          Add Feedback
                        </h4>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label
                            className="text-gray-700"
                            style={{ fontSize: "14px" }}
                          >
                            Manager Name
                          </label>
                          <input
                            type="text"
                            value={managerReviewData[0]?.manager_name || ""}
                            readOnly
                            className="w-full text-gray-800 border-gray-300 rounded-lg p-2"
                            style={{ fontSize: "14px" }}
                          />
                        </div>
                        <div>
                          <label
                            className="text-gray-700"
                            style={{ fontSize: "14px" }}
                          >
                            Date
                          </label>
                          <input
                            type="text"
                            value={new Date().toLocaleDateString()}
                            readOnly
                            className="w-full text-gray-500 border-gray-300 rounded-lg p-2"
                            style={{ fontSize: "14px" }}
                          />
                        </div>
                        <div>
                          <label
                            className="text-gray-700"
                            style={{ fontSize: "14px" }}
                          >
                            Comment
                          </label>
                          <textarea
                            value={managercomments}
                            className="w-full text-gray-600 border-gray-300 rounded-lg p-2"
                            style={{
                              fontSize: "14px",
                              maxHeight: "290px",
                              border: "1px solid lightgray",
                            }}
                            rows="3"
                            placeholder="Enter your feedback here..."
                            onChange={(e) => setManagercomments(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="flex justify-end gap-2 mt-4">
                        <button
                          className="px-4 py-2 rounded-lg text-white focus:outline-none"
                          style={{ backgroundColor: "#C9302C", color: "white" }}
                          onClick={() => setManagerreview(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="px-4 py-2 rounded-lg text-white focus:outline-none"
                          onClick={handleManagerReview}
                          style={{
                            backgroundColor: "#286090",
                            color: "white",
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {deletereview && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
                    <div
                      className="bg-white rounded-lg p-6 shadow-lg flex justify-center items-center flex-col"
                      style={{ width: "400px", height: "150px" }}
                    >
                      <h4
                        className="text-gray-700 font-bold mb-4"
                        style={{ fontSize: "18px" }}
                      >
                        Delete This Feedback
                      </h4>

                      <div className="flex justify-center gap-4 mt-4">
                        <button
                          className="btn btn-danger"
                          onClick={() => setDeletereview(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={handleDeleteReview}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default AgentInsight;
